import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MarkupType } from 'src/app/shared/services/quote.service';

export type markupValidationParams = {
  markup: number;
  type: MarkupType;
  retailCost: number;
  planId: number;
};

export type SupplementCoverageFormControls = {
  type: FormControl<string | null>;
  premium: FormControl<number | null>;
  ttm_limit: FormControl<number | null>;
  total_ttm: FormControl<number | null>;
};

export type CoverageFormControls = {
  selected: FormControl<boolean | null>;
  customer_cost: FormControl<string | number | null>;
  quote_id: FormControl<number | null>;
  coverage: FormControl<string | null>;
  premium: FormControl<number | null>;
  coverage_id: FormControl<number>;
  suplement_coverages: FormArray<FormGroup<SupplementCoverageFormControls>>;
};

export type QuoteDetailsFormControls = {
  ttm_limit: FormControl<number | null>;
  ttm_claim_limit: FormControl<number | null>;
  ttm: FormControl<boolean | null>;
  dealer_markup_toggle: FormControl<boolean | null>;
  dealer_markup: FormControl<number | null>;
  coverage_term: FormControl<string | null>;
  coverage: FormControl<string | null>;
  coverages: FormArray<FormGroup<CoverageFormControls>>;
  presale_number: FormControl<number | string | null>;
  markup_type: FormControl<string | null>;
  markup_amount: FormControl<number | string | null>;
};
export enum MarkupTypeMultiTerm {
  fixed = 'flat_fee',
  percentage = 'percentage'
}
